import { type TextInputProps, Menu, Button, type ButtonProps } from '@mantine/core'
import clsx from 'clsx'

import styles from './styles.module.css'

export type DropdownUrlProtocolProps = Omit<TextInputProps, 'onChange'> & {
  size?: ButtonProps['size']
  currentProtocol: string
  withErrors?: boolean
  onChange?: (protocol: string) => void
}

export function DropdownUrlProtocol({
  size = 'md',
  withErrors = false,
  currentProtocol,
  onChange,
}: DropdownUrlProtocolProps) {
  const protocols = ['https://', 'http://']

  return (
    <Menu position='bottom-start' withinPortal zIndex={9999999}>
      <Menu.Target>
        <Button
          variant='default'
          className={clsx(styles.dropdownTrigger, styles[size], {
            [styles.dropdownTriggerHasErrors]: withErrors,
          })}
        >
          {currentProtocol}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {protocols.map((protocol, key) => (
          <Menu.Item
            key={key}
            onClick={() => onChange?.(protocol)}
          >
            {protocol}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
